module.exports = __webpack_public_path__ + "img/browser.fb79f20e.svg";